import { c as _c } from "react/compiler-runtime";
import { useMediaQuery } from '@react-hookz/web/useMediaQuery/index.js';
import { useEffect, useMemo, useState } from 'react';
import type { Breakpoint } from '#types/enums';
import { mediaQueries } from '../styles/media';
export function useBreakpoints(breakpoints) {
  const $ = _c(5);
  if (Object.keys(breakpoints).length < 2) {
    throw new Error("You must supply at least two breakpoints");
  }
  let t0;
  if ($[0] !== breakpoints) {
    t0 = Object.entries(breakpoints).sort(_temp).map(_temp2);
    $[0] = breakpoints;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const internalBreakpoints = t0;
  const [currentBreakpoint, setCurrentBreakpoint] = useState(undefined);
  let t1;
  let t2;
  if ($[2] !== internalBreakpoints) {
    t1 = () => {
      if (typeof window !== "undefined") {
        const handlers = [];
        for (const mediaQuery of internalBreakpoints) {
          const mql = window.matchMedia(mediaQuery.query);
          const listener = function listener(e) {
            if (e.matches) {
              setCurrentBreakpoint(mediaQuery.name);
            }
          };
          mql.addEventListener("change", listener);
          handlers.push({
            mql,
            handler: listener
          });
          if (mql.matches) {
            setCurrentBreakpoint(mediaQuery.name);
          }
        }
        return () => {
          for (const {
            mql: mql_0,
            handler
          } of handlers) {
            mql_0.removeEventListener("change", handler);
          }
        };
      }
    };
    t2 = [internalBreakpoints];
    $[2] = internalBreakpoints;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return currentBreakpoint;
}
function _temp2(t0, index, arr) {
  const [name, value] = t0;
  let query;
  if (index === 0) {
    query = `only screen and (width < ${arr[1][1]}px)`;
  } else {
    if (index === arr.length - 1) {
      query = `only screen and (width >= ${value}px)`;
    } else {
      query = `only screen and (width >= ${value}px) and (width < ${arr[index + 1][1]}px)`;
    }
  }
  return {
    name,
    value,
    query
  };
}
function _temp(t0, t1) {
  const [, a] = t0;
  const [, b] = t1;
  return a - b;
}
export function useBreakpoint(breakpoint) {
  const mediaQuery = mediaQueries[breakpoint];
  return useMediaQuery(mediaQuery ?? "not all", {
    initializeWithValue: false
  }) ?? false;
}